import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Profile Linking", -1)
const _hoisted_2 = { class: "dialog-content flex-column connect-social-dialog" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { useDialogStore } from '@/stores/dialogs';
import { useFacebookStore } from '@/stores/facebook';
import { useTiktokStore } from '@/stores/tiktok';
import VButton from '../VButton.vue';
import { useInstagramStore } from '@/stores/instagram';
import FacebookIcon from '@/components/icons/other/FacebookIcon.vue'
import InstagramIcon from '@/components/icons/other/InstagramIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectSocialDialog',
  setup(__props) {

const facebookStore = useFacebookStore()
const instagramStore = useInstagramStore();
const tiktokStore = useTiktokStore()

const dialog = useDialogStore()
const close = () => {
  dialog.back()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" Facebook pulls in Business Manager, Pages, and any Instagram accounts linked to those Pages."),
      _hoisted_3,
      _createTextVNode(" Instagram connects just your standalone Professional account. "),
      _createVNode(VButton, {
        class: "mt-4",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(facebookStore).connectFacebook()))
      }, {
        default: _withCtx(() => [
          _createVNode(FacebookIcon),
          _createTextVNode("Connect Facebook")
        ]),
        _: 1
      }),
      _createVNode(VButton, {
        class: "mt-2 instagram",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(instagramStore).connectInstagram()))
      }, {
        default: _withCtx(() => [
          _createVNode(InstagramIcon),
          _createTextVNode("Connect Instagram")
        ]),
        _: 1
      }),
      _createElementVNode("a", {
        class: "mt-2 mb-3 clickable",
        onClick: close
      }, "I will do this later")
    ])
  ], 64))
}
}

})